export function rebalanceShares(
  shares: Readonly<Record<string, number>>,
  id: string,
  value: number,
): Record<string, number> {
  const weights = { ...shares, "": 100 - Object.values(shares).reduce((a, b) => a + b, 0) };
  const entries = Object.entries(weights)
    .filter(([key]) => key !== id)
    .sort(([a], [b]) => (a < b ? -1 : 1));
  const total = entries.reduce((sum, [, weight]) => sum + weight, 0);
  const result: Record<string, number> = { [id]: value };
  let left = 100 - value;
  for (const [key, weight] of entries) {
    result[key] = total ? Math.floor((weight * (100 - value)) / total) : 0;
    left -= result[key] as number;
  }
  if (!total) result[""] = left;
  else
    for (const [key] of [...entries].sort(
      (a, b) => ((b[1] * (100 - value)) % total) - ((a[1] * (100 - value)) % total),
    )) {
      if (left-- > 0) result[key] = (result[key] as number) + 1;
    }
  delete result[""];
  return result;
}
